/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import Body from "ui/kit/typography/Body";
import MIDI from "state/midi";

const PiecePlayMIDIStatus: React.FC = () => {

    const midiContext = React.useContext(MIDI)

    switch (midiContext.status) {
        case "needs_setup":
            return <Body>Setting up MIDI</Body>
        case "browser_not_supported":
            return <Body>Browser does not support MIDI. We recommend Google Chrome.</Body>
        case "connected":
            if (midiContext.deviceNames && midiContext.deviceNames.length > 0) {
                const deviceNames = midiContext.deviceNames.join(", ");
                return <Body>Connected to <i>{deviceNames}</i></Body>
            } else {
                return <Body>Plug in a MIDI enabled keyboard to get playing.</Body>
            }
    }

    return (
        <Body>MIDI Status</Body>
    );
}

export default PiecePlayMIDIStatus;